import React, { Component } from "react";
import SubjectFileUpload from "../subjectFileUpload";
import ProductionFileUpload from "../productionFileUpload";
import ValidationForm from "../ValidationForm";
import ReferencesForm from "../referencesForm";
import {
  ReferenceBook,
  ReferenceTest,
  ReferenceOther,
} from "../referencesForm";
import CommentForm from "../commentForm";
import FormularHeader from "components/common/formular-header";
import { submitProblem } from "server/Exercises CRUD/Requests";
import toast from "react-hot-toast";
import {
  validateSubmissionFields,
  validateCompleteSubmission,
} from "../StudentSubmissionUtils";

// Définir le type pour l'état
interface State {
  step: number;
  maxStep: number;
  [key: string]: any;
  // 'subjectFileIds': File[],
  // 'productionFileIds': File[],
  // 'submissionType': string,
  // 'referenceType': string,
  // 'comment': string,
  // 'referenceBook': ReferenceBook | null,
  // 'referenceOther': ReferenceOther | null,
  // 'referenceTest': ReferenceTest | null,
  isSubmitting: boolean;
}

interface Props {
  onCancel?: () => void;
  onSuccess?: () => void;
}

class UnclearFormular extends Component<Props, State> {
  state: State = {
    step: 1,
    maxStep: 3,
    subjectFileIds: [],
    productionFileIds: [],
    submissionType: "unclear",
    referenceType: "",
    comment: "",
    referenceBook: null,
    referenceOther: null,
    referenceTest: null,
    isSubmitting: false,
  };

  subjectFiles: File[] = [];
  productionFiles: File[] = [];

  // revenir à l'étape précédente
  prevStep = (): void => {
    const { step } = this.state;
    if (step > 1) {
      this.setState({ step: step - 1 });
    }
  };

  // passer à l'étape suivante
  nextStep = (): void => {
    const { step } = this.state;
    const { maxStep } = this.state;

    // Validation avant de passer à l'étape suivante
    const validation = validateSubmissionFields("unclear", step, this.state);

    if (!validation.isValid) {
      validation.errors.forEach((error) => {
        toast.error(error);
      });
      return;
    }

    if (step < maxStep) {
      this.setState({ step: step + 1 });
    }
    console.log(this.state);
  };

  // Gérer le changement de champs
  handleChange =
    (input: string) =>
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
      this.setState({ [input]: e.target.value });
      // console.log(this.state[input]);
    };

  // Vérifier si l'étape actuelle est valide
  isCurrentStepValid = (): boolean => {
    const validation = validateSubmissionFields(
      "unclear",
      this.state.step,
      this.state,
    );
    return validation.isValid;
  };

  handleSaveDraft = () => {
    console.log("Sauvegarder Brouillon a été cliqué");
  };

  handleCancel = () => {
    this.setState({
      step: 1,
      maxStep: 3,
      subjectFileIds: [],
      productionFileIds: [],
      submissionType: "unclear",
      referenceType: "",
      comment: "",
      referenceBook: null,
      referenceOther: null,
      referenceTest: null,
      isSubmitting: false,
    });
    toast("Formulaire annulé. Retour à la liste.");
    if (this.props.onCancel) this.props.onCancel();
  };

  handleSuccess = () => {
    this.setState({
      step: 1,
      maxStep: 3,
      subjectFileIds: [],
      productionFileIds: [],
      submissionType: "unclear",
      referenceType: "",
      comment: "",
      referenceBook: null,
      referenceOther: null,
      referenceTest: null,
      isSubmitting: false,
    });
    toast.success("Soumission réussie ! Vous avez été redirigé vers la liste.");
    if (this.props.onSuccess) this.props.onSuccess();
  };

  handleSubmit = async () => {
    // Validation complète avant soumission
    const validation = validateCompleteSubmission("unclear", this.state);

    if (!validation.isValid) {
      validation.errors.forEach((error) => {
        toast.error(error);
      });
      return;
    }

    const {
      subjectFileIds,
      productionFileIds,
      referenceType,
      submissionType,
      comment,
      referenceBook,
      referenceOther,
      referenceTest,
    } = this.state;
    const input: any = {
      subjectFileIds,
      productionFileIds: [], // Pas de fichiers de production pour "unclear"
      submissionType,
      referenceType,
      comment,
      referenceBook,
      referenceOther,
      referenceTest,
    };
    console.log("Payload envoyé :", input);
    this.setState({ isSubmitting: true });

    try {
      const response = await submitProblem(input);

      if (response.status === 200) {
        this.setState({ isSubmitting: false });
        this.handleSuccess();
      } else {
        // Gestion des erreurs HTTP spécifiques
        this.setState({ isSubmitting: false });
        const errorMessage = this.getErrorMessage(
          response.status,
          response.body,
        );
        toast.error(errorMessage);
      }
    } catch (error) {
      // Gestion des erreurs réseau ou autres
      this.setState({ isSubmitting: false });
      console.error("Erreur lors de la soumission:", error);
      toast.error(
        "Erreur de connexion. Veuillez vérifier votre connexion internet et réessayer.",
      );
    }
  };

  // Fonction pour obtenir des messages d'erreur spécifiques selon le code de statut
  getErrorMessage = (status: number, body: any): string => {
    const errorMessage = body?.message || "Une erreur est survenue";

    switch (status) {
      case 400:
        return `Données invalides : ${errorMessage}`;
      case 401:
        return "Vous devez être connecté pour signaler un problème. Veuillez vous reconnecter.";
      case 403:
        return "Vous n'avez pas l'autorisation de signaler un problème.";
      case 413:
        return "Les fichiers sont trop volumineux. Veuillez réduire leur taille.";
      case 422:
        return `Erreur de validation : ${errorMessage}`;
      case 429:
        return "Trop de soumissions. Veuillez attendre quelques minutes avant de réessayer.";
      case 500:
        return "Erreur serveur. Veuillez réessayer plus tard.";
      case 502:
      case 503:
      case 504:
        return "Service temporairement indisponible. Veuillez réessayer plus tard.";
      default:
        return `Erreur ${status} : ${errorMessage}`;
    }
  };

  render() {
    const { step } = this.state;
    const { maxStep } = this.state;
    const {
      subjectFileIds,
      productionFileIds,
      submissionType,
      referenceType,
      comment,
      referenceBook,
      referenceOther,
      referenceTest,
    } = this.state;
    const values = {
      subjectFileIds,
      productionFileIds,
      submissionType,
      referenceType,
      comment,
      referenceBook,
      referenceOther,
      referenceTest,
    };
    switch (step) {
      case 1:
        return (
          <div className="flex flex-col items-center min-h-full w-full bg-white px-4 py-6">
            <FormularHeader
              onCancel={this.handleCancel}
              onSaveDraft={this.handleSaveDraft}
              onNext={this.nextStep}
              onPrev={this.prevStep}
              isNextDisabled={!this.isCurrentStepValid()}
            />
            <div className="w-full max-w-4xl bg-white rounded-2xl p-8 space-y-8">
              <div className="text-center">
                <h2 className="text-3xl font-bold text-gray-800 mb-2">
                  Impossible de démarrer
                </h2>
              </div>

              <ProgressBar
                totalSteps={this.state.maxStep}
                step={this.state.step}
              />

              <div className="text-center space-y-4">
                <h3 className="text-xl font-semibold text-gray-800">
                  Ajoutez les fichiers du sujet
                </h3>
                <p className="text-gray-600 max-w-2xl mx-auto">
                  Prenez une (des) photo(s) lisible(s) ou un (des) document(s)
                  scanné(s) du sujet qui vous pose problème.
                </p>
              </div>

              <SubjectFileUpload
                onSend={(files: File[]) => {
                  this.subjectFiles = files;
                  this.setState({ subjectFileIds: files });
                }}
                handleChange={this.handleChange}
                values={values}
              />
            </div>
          </div>
        );
      case 2:
        return (
          <div className="flex flex-col items-center min-h-full w-full bg-white px-4 py-6">
            <FormularHeader
              onCancel={this.handleCancel}
              onSaveDraft={this.handleSaveDraft}
              onNext={this.nextStep}
              onPrev={this.prevStep}
              isNextDisabled={!this.isCurrentStepValid()}
            />
            <div className="w-full max-w-4xl bg-white rounded-2xl  p-8 space-y-8">
              <div className="text-center">
                <h2 className="text-3xl font-bold text-gray-800 mb-2">
                  Impossible de démarrer
                </h2>
              </div>

              <ProgressBar
                totalSteps={this.state.maxStep}
                step={this.state.step}
              />

              <div className="text-center space-y-4">
                <h3 className="text-xl font-semibold text-gray-800">
                  Références du sujet
                </h3>
                <p className="text-gray-600 max-w-2xl mx-auto">
                  Renseignez les références de votre sujet pour nous aider à
                  identifier le problème.
                </p>
              </div>

              <ReferencesForm
                onSend={(referenceType, data) => {
                  switch (referenceType) {
                    case "livre":
                      this.setState({
                        referenceType: referenceType,
                        referenceBook: data,
                      });
                      this.setState({
                        referenceTest: null,
                        referenceOther: null,
                      });
                      break;
                    case "epreuve":
                      this.setState({
                        referenceType: referenceType,
                        referenceTest: data,
                      });
                      this.setState({
                        referenceBook: null,
                        referenceOther: null,
                      });
                      break;
                    case "other":
                      this.setState({
                        referenceType: referenceType,
                        referenceOther: data,
                      });
                      this.setState({
                        referenceTest: null,
                        referenceBook: null,
                      });
                      break;
                    default:
                      console.error("Type de référence invalide");
                  }
                }}
                handleChange={this.handleChange}
                values={values}
              />
            </div>
          </div>
        );
      case 3:
        return (
          <div className="flex flex-col items-center min-h-full w-full bg-white px-4 py-6">
            <FormularHeader
              onCancel={this.handleCancel}
              onSaveDraft={this.handleSaveDraft}
              onNext={this.handleSubmit}
              onPrev={this.prevStep}
              isMaxStep={true}
              isSubmitting={this.state.isSubmitting}
            />
            <div className="w-full max-w-4xl bg-white rounded-2xl  p-8 space-y-8">
              <div className="text-center">
                <h2 className="text-3xl font-bold text-gray-800 mb-2">
                  Impossible de démarrer
                </h2>
              </div>

              <ProgressBar
                totalSteps={this.state.maxStep}
                step={this.state.step}
              />

              <div className="text-center space-y-4">
                <h3 className="text-xl font-semibold text-gray-800">
                  Décrivez votre problème
                </h3>
                <p className="text-gray-600 max-w-2xl mx-auto">
                  Dites-nous ce qui vous empêche de démarrer cet exercice.
                </p>
              </div>

              <CommentForm
                onSend={(comment: string) => {
                  this.setState({ comment: comment });
                }}
                handleChange={this.handleChange}
                values={values}
              />
            </div>
          </div>
        );

      default:
      // do nothing for now
    }
  }
}

export default UnclearFormular;

interface ProgressBarProps {
  totalSteps: number;
  step: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ totalSteps, step }) => {
  const percentage = (step / totalSteps) * 100;

  return (
    <div className="w-full max-w-md mx-auto px-4">
      <div className="flex justify-between text-sm text-gray-600 mb-2">
        <span>
          Étape {step} sur {totalSteps}
        </span>
        <span>{Math.round(percentage)}%</span>
      </div>
      <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
        <div
          style={{ width: `${percentage}%` }}
          className="h-full bg-gradient-to-r from-[#E3B505] to-[#F4D03F] transition-all duration-300 ease-out"
        />
      </div>
    </div>
  );
};
